<!--
 * Path: packages/frontend/src/features/browser/forms/datetime/DateTimeEdit.vue
 * Task: HTML5 native datetime picker integration.
-->
<template>
  <v-text-field
    v-model="modelValue"
    type="datetime-local"
    variant="outlined"
    density="compact"
    hide-details="auto"
    :error-messages="errorMessages"
    autofocus
    @keydown.enter="$emit('save')"
    class="mb-0"
  ></v-text-field>
</template>

<script setup lang="ts">
defineProps<{
  errorMessages?: string | string[];
}>();

defineEmits<{ (e: 'save'): void }>();

const modelValue = defineModel<string | null>();
</script>
